import { useEffect } from 'react'

const importSVGs = async () => {
  ;(
    await Promise.all([
      import('../assets/sprite.svg?raw'),
      import('../assets/sprite16.svg?raw'),
      import('../assets/spriteCustom.svg?raw'),
      import('../assets/spritePredefined.svg?raw')
    ])
  ).forEach((svgContent) => {
    const div = document.createElement('div')
    div.style.position = 'absolute'
    div.style.width = '0'
    div.style.height = '0'
    div.style.overflow = 'hidden'
    div.innerHTML = svgContent.default
    document.body.appendChild(div)
  })
}

export const SpriteLoader = () => {
  useEffect(() => {
    void importSVGs()
  }, [])

  return null
}
